import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_51: FaireProductEntity = {
  token: "legacy_prod_abbott-51",
  type: "product",
  name: "Nutcracker Pedestal Cake Plate (Clearance)",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a4d7c30866c98c741bc5f18bd1c248bc96c827babc6095e35e3c135ac5201751.jpeg",
  priceDollars: 22,
  msrpDollars: 44,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
